import * as React from 'react';
import { EngineeringReviewList, EngineeringReviewReasonMetadata  } from '../../../../modules/ordering/models/engineering-review-list';
import { PendingReason, PendingReasonMetadata } from '../../../../models/ordering/enums/pending-reason';
import { toSlashedShortDate } from '../../../../utils/date-utils';

interface IProps {
    onOrderClick: any;
    order: EngineeringReviewList;
}

export const EngineeringReviewOrderRow = (props: IProps) => {

    const getReasonDisplay = () => {
        if (props.order.reason != null) {
            return EngineeringReviewReasonMetadata[props.order.reason]?.display ?? '';
        }

        if (props.order.pendingReason & PendingReason.CustomerServiceReview) {
            return PendingReasonMetadata[PendingReason.CustomerServiceReview]?.display ?? '';
        }

        if (props.order.pendingReason & PendingReason.AddressReview) {
            return PendingReasonMetadata[PendingReason.AddressReview]?.display ?? '';
        }
        return '';
    };

    return (
        <tr onClick={() => props.onOrderClick(props.order.orderId)}>
            <td><a>{props.order.orderId}</a></td>
            <td>{props.order.description}</td>
            <td>{props.order.cutoffDate ? toSlashedShortDate(props.order.cutoffDate) : ''}</td>
            <td>{getReasonDisplay()}</td>
        </tr>
    );
};
